const studioOnboarding = [
	{
		path: '/agency/showcase/private-invites',
		name: 'agency-showcase-private-invites',
		component: () => import('@/views/agency/showcase/private-invites.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/studio-onboarding/invites',
		name: 'agency-studio-onboarding-invites',
		component: () => import('@/views/agency/studio-onboarding/invites.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/studio-onboarding/questions',
		name: 'agency-studio-onboarding-questions',
		component: () => import('@/views/agency/studio-onboarding/questions.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/studio-onboarding/submissions',
		name: 'agency-studio-onboarding-submissions',
		component: () => import('@/views/agency/studio-onboarding/submissions.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/studio-onboarding/followups',
		name: 'agency-studio-onboarding-followups',
		component: () => import('@/views/agency/studio-onboarding/followups.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
]

export default studioOnboarding
